import moment from 'moment'
export const timeZone = 'Asia/Bangkok'
export const timeFormat = 'YYYY-MM-DDTHH:mm:ss'
export const dateDisplay = 'DD MMM YYYY'
export const dateTimeDisplay = 'DD MMM YYYY HH:mm'
export const timeDisplay = 'HH:mm'

export const groupFBSbyCatagory = (fbsList) => {
    let result = []
    if (Array.isArray(fbsList) && fbsList.length > 0) {
        fbsList.forEach(element => {
            const { fbCategoryId, fbCategory } = element
            const { name, _id } = fbCategoryId ? fbCategory : null
            let findIndexCategory = result.findIndex(r => r.fbCategoryId === _id)
            if (findIndexCategory > -1) {
                let data = result[findIndexCategory].data
                result[findIndexCategory].data = data.concat(element)
            } else result.push({ fbCategoryId: _id, name: name, data: [element] })
        });
    }
    return result
}

export const dateFormatBetweenStartEnd = (start, end) => {
    if (!start || !end) return null
    let dateString = "", timeString = ""

    if (moment(start).isSame(end, "day")) {
        dateString = moment(moment(start).toDate()).format(dateDisplay).toString()
        timeString = moment(moment(start).toDate()).format(timeDisplay).toString()
        timeString += " - " + moment(moment(end).toDate()).format(timeDisplay).toString()
        return { date: dateString, time: timeString, isSameDate: true }
    }
    else {
        let dateObj = {}
        dateObj.start = moment(moment(start).toDate()).format(dateTimeDisplay).toString()
        dateObj.end = moment(moment(end).toDate()).format(dateTimeDisplay).toString()
        return { ...dateObj, isSameDate: false }
    }

}


// WEBPACK FOOTER //
// ./src/lib/setting.js